const axios = require('axios')
const api_base = process.env.VUE_APP_API_BASE_URL

const login = async (operatorCredentials) => {
    const url = `${api_base}/v1/operators/login`

    const result = await post(url, operatorCredentials)
    return result
}

const logout = async () => {
    const url = `${api_base}/v1/operators/logout`

    const session = localStorage.getItem('session_id')
    const result = await post(url, { session_id: session })
    localStorage.clear()

    return result
}

const me = async () => {
    const session = localStorage.getItem('session_id')
    const url =  `${api_base}/v1/operators/me/${session}`

    const no_session = {
        data: {
            user: {
                session_id: 'N/A'
            }
        }
    }

    const profile = await axios.get(url)
        .catch(() => {
            return no_session
        })

    return profile.data
}

// PRIVATES
const post = async (url, data) => {
    const result = await axios.post(url, data)
        .catch((error) => {
            console.log(error)
            const retError = {
                errors: error.response.data
            }

            retError.status = error.response.status
            
            return retError
        })

    return result
}

module.exports = {
    login,
    logout,
    me
}